import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { MANUAL_JOURNAL_ENTRY_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  communityId: string;
  documentTypeId: string;
  data: FieldValues;
}
const mutateValidateMJEExcel = async ({ communityId, documentTypeId, data }: mutateProps) => {
  return await axiosAuth.post(`${MANUAL_JOURNAL_ENTRY_API(communityId)}/validate-excel?documentTypeId=${documentTypeId}`, data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useValidateMJEExcelMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateValidateMJEExcel,
    ...queryParams,
  });

export default useValidateMJEExcelMutation;
